import RefDataCrudPage from './RefDataCrudPage'
import { employeeStatusesApi } from '../api/lookupApi'

export default function PersonnelStatusesPage() {
  return <RefDataCrudPage api={employeeStatusesApi} i18nPrefix="optionDefs.personnelStatuses" showColor />
}
